import { JourneyStepFilterPipe } from '../../../filters/journey-step-filter.pipe';
import { TranslatePipe } from '../../../filters/translate.pipe';
import { PreVisitThankYouComponentComponent } from '../../../components/pre-visit/thank-you/pre-visit-thank-you.component';
import { InputDatepickerNewComponent } from '../../../components/input-datepicker-new/input-datepicker-new.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { LoaderOverlayComponent } from '../../../components/loader-overlay/loader-overlay.component';
import Session from '../../../utils/session.service';
import RestService from '../../../services/core-rest.service';
import PreVisitRecordTicketForPersonService from '../../../services/pre-visit-record-ticket-for-person.service';
import AngularHelperService from '../../../services/angular-helper.service';
import AngularFilterHelperService from '../../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';
import RoutingService from '../../../services/routing.service';
import { PanelDirective } from '../../../directives/panel.directive';

@Component({
	standalone: true,
	selector: 'pre-visit-general-service-request',
	templateUrl: './pre-visit-general-service-request.component.html',
	imports: [
		CommonModule, PanelDirective, JourneyStepFilterPipe, TranslatePipe, 
		PreVisitThankYouComponentComponent, FormsModule, LoaderOverlayComponent, 
		InputDatepickerNewComponent, RouterLink
	]
})
export default class PreVisitGeneralServiceRequestComponent implements OnInit, OnDestroy {
	private session: Session = inject(Session);
	private restService: RestService = inject(RestService);
	private preVisitRecordTicketForPersonService: PreVisitRecordTicketForPersonService = inject(PreVisitRecordTicketForPersonService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	selectedServiceWatcher: any = undefined;
	radioSelectedValue: any;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('preVisitDashboard').then(() => {
			this.loadConfig();
		});
	}
	
	ngOnDestroy() {
		if (this.selectedServiceWatcher) {
			this.angularHelperService.cancelInterval(this.selectedServiceWatcher);
		}
	}
	
	loadConfig() {
		var parentCategory: any = this.angularRoutingHelperService.getQueryParams()['parentCategory'];
		if (parentCategory === 'SICK_LEAVE_CERTIFICATE_REQUEST') {
			const twoWeeksAgo = new Date();
			twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);
			this.vm.minDate = twoWeeksAgo;
		}
		this.restService.getPreVisitTicketConfig({ 'parentCategory': parentCategory })
			.then((parentCategoryConfig) => {
				this.vm.parentCategoryConfig = parentCategoryConfig;
				this.onResolve();
			})
			.catch((error) => {
				console.log(error);
			});
	}
	
	onResolve() {
		this.vm.showOnlyThankYouSection = false;
		this.vm.isSaving = false;
		this.vm.isRecordTicketForPerson = false;
		this.vm.thankYouInformationSection = "<p>"
			+ this.angularFilterHelperService.translate('PreVisit.Prescription_Checkout.Application_Forwarded')
			+ "</p>"
			+ "<p>"
			+ this.angularFilterHelperService.translate('PreVisit.Symptom_Check_Results.Contacted_In_Level_1')
			+ "</p>";
		
		this.vm.user = this.session.getSession().user;
		this.vm.serviceInfo = this.vm.parentCategoryConfig;
		this.vm.isOpen = { service: true, consents: true };
		this.vm.selectedServiceIds = {};
		this.vm.journeySteps = [];
		this.vm.required = {
			"MANDATORY": true,
			"ONE_IN_STEP": false
		}
		this.vm.isRecordTicketForPerson = !!this.preVisitRecordTicketForPersonService.getPatient();
		
		this.vm.parentCategory = this.angularRoutingHelperService.getQueryParams()['parentCategory'];
		var currentServiceIds = {};
		if (this.selectedServiceWatcher) {
			this.angularHelperService.cancelInterval(this.selectedServiceWatcher);
		}
		this.selectedServiceWatcher = this.angularHelperService.createInterval(() => {
			if (!this.angularHelperService.isEqual(this.vm.selectedServiceIds, currentServiceIds)) {
				currentServiceIds = Object.assign({}, this.vm.selectedServiceIds);
				this.onServiceIdChanges();
			}
			
			var newParentCategory = this.angularRoutingHelperService.getQueryParams()['parentCategory'];
			if (this.vm.parentCategory !== newParentCategory) {
				this.loadConfig();
			}
		}, 300);
		
		var title: any = ('PreVisit.Card.Title_NEW_' + this.vm.parentCategory).replace('NEW_NEW', 'NEW');
		this.vm.headerText = this.angularFilterHelperService.translate(title);
		
		this.initializeJourneyStepsAndSetCurrentStep();
		
		this.vm.handleFormSubmit = this.submit;
		this.vm.journeyNextStep = this.journeyNextStep;
		this.vm.journeyPreviousStep = this.journeyPreviousStep;
		this.vm.getSafeHtml = this.getSafeHtml;
	}
	
	onServiceIdChanges() {
		for (var selectedServiceId in this.vm.selectedServiceIds) {
			var id: any = this.vm.selectedServiceIds[selectedServiceId];
			if (!id) {
				for (var index in this.vm.serviceInfo) {
					var serviceSelectionElement: any = this.vm.serviceInfo[index];
					if (serviceSelectionElement.id == selectedServiceId && serviceSelectionElement.groupedBy) {
						this.removeJourneyStep(serviceSelectionElement.groupedBy);
						this.removeSelectedServiceChildren(serviceSelectionElement.groupedBy);
						this.updateJourneySteps(this.vm);
					}
				}
				delete this.vm.selectedServiceIds[selectedServiceId];
			}
			if (id) {
				for (var index in this.vm.serviceInfo) {
					var serviceSelectionElement: any = this.vm.serviceInfo[index];
					if (serviceSelectionElement.step === this.vm.currentJourneyStep && selectedServiceId == serviceSelectionElement.id
						&& serviceSelectionElement.required === 'ONE_IN_STEP') {
						this.vm.required['ONE_IN_STEP'] = false;
					}
				}
			}
		}
	}
	
	initializeJourneyStepsAndSetCurrentStep() {
		this.updateJourneySteps(this);
		this.vm.currentJourneyStep = this.vm.journeySteps[0];
		this.initCurrentStepSettings();
	}
	
	getSafeHtml(input) {
		return this.angularHelperService.trustAsHtml(input);
	}
	
	journeyPreviousStep() {
		this.vm.stepInvalid = false;
		if (this.vm.currentJourneyStep > this.vm.journeySteps[this.vm.journeySteps.indexOf(this.vm.currentJourneyStep) - 1]) {
			this.vm.currentJourneyStep = this.vm.journeySteps[this.vm.journeySteps.indexOf(this.vm.currentJourneyStep) - 1];
			this.initCurrentStepSettings();
			
			if (this.vm.journeySteps.indexOf(this.vm.currentJourneyStep) === 0) {
				this.vm.journeySteps = [];
				this.updateJourneySteps(this.vm);
			}
		} else {
			window.history.back();
		}
	}
	
	journeyNextStep() {
		this.vm.submitted = true;
		if (this.isStepInvalid()) {
			return;
		}
		if (this.vm.journeySteps.indexOf(this.vm.currentJourneyStep) === (this.vm.journeySteps.length - 1) && this.vm.journeySteps.length !== 1) {
			this.submit();
			return;
		}
		for (var index in this.vm.serviceInfo) {
			for (var selectedServiceId in this.vm.selectedServiceIds) {
				var serviceSelectionElement: any = this.vm.serviceInfo[index];
				if (serviceSelectionElement.id == selectedServiceId
					&& this.vm.selectedServiceIds[selectedServiceId]
					&& serviceSelectionElement.groupedBy) {
					this.updateJourneySteps(this.vm, serviceSelectionElement.groupedBy);
				}
			}
		}
		if (this.vm.journeySteps.indexOf(this.vm.currentJourneyStep) === (this.vm.journeySteps.length - 1)) {
			this.submit();
			return;
		}
		if (!!this.vm.journeySteps[this.vm.journeySteps.indexOf(this.vm.currentJourneyStep) + 1]) {
			this.vm.currentJourneyStep = this.vm.journeySteps[this.vm.journeySteps.indexOf(this.vm.currentJourneyStep) + 1];
			this.initCurrentStepSettings();
			this.vm.submitted = false;
		}
		
	}
	
	initCurrentStepSettings() {
		for (var index in this.vm.serviceInfo) {
			var serviceSelectionElement: any = this.vm.serviceInfo[index];
			if (serviceSelectionElement.step && this.vm.currentJourneyStep === serviceSelectionElement.step) {
				if (serviceSelectionElement.required === 'ONE_IN_STEP') {
					this.vm.required['ONE_IN_STEP'] = true;
				} else {
					this.vm.required['ONE_IN_STEP'] = false;
				}
			}
		}
	}
	
	updateJourneySteps(caller, groupedById?) {
		for (var index in caller.vm.serviceInfo) {
			var serviceSelectionElement: any = caller.vm.serviceInfo[index];
			if (serviceSelectionElement.defaultStep && caller.vm.journeySteps.indexOf(serviceSelectionElement.step) === -1) {
				caller.vm.journeySteps.push(serviceSelectionElement.step);
			}
			if (serviceSelectionElement.groupedBy === groupedById 
				&& serviceSelectionElement.step
				&& caller.vm.currentJourneyStep !== serviceSelectionElement.step
				&& caller.vm.journeySteps.indexOf(serviceSelectionElement.step) === -1) {
				caller.vm.journeySteps.push(serviceSelectionElement.step);
			}
		}
		
		caller.vm.journeySteps.sort((a, b) => {
			return a - b;
		});
	}
	
	removeJourneyStep(groupedById) {
		for (var index in this.vm.serviceInfo) {
			var serviceSelectionElement: any = this.vm.serviceInfo[index];
			var placementInSelection: any = this.vm.journeySteps.indexOf(serviceSelectionElement.step);
			
			if (serviceSelectionElement.groupedBy === groupedById && placementInSelection !== -1) {
				this.vm.journeySteps = this.vm.journeySteps.splice(placementInSelection, placementInSelection);
			}
		}
	}
	
	removeSelectedServiceChildren(groupedById) {
		for (var selectedServiceId in this.vm.selectedServiceIds) {
			for (var index in this.vm.serviceInfo) {
				var serviceSelectionElement: any = this.vm.serviceInfo[index];
				if (serviceSelectionElement.id == selectedServiceId && serviceSelectionElement.groupedBy === groupedById) {
					delete this.vm.selectedServiceIds[selectedServiceId];
				}
			}
		}
	}
	
	onRadioChange(selectedId) {
		this.vm.selectedServiceIds[selectedId] = true;
		for (var index in this.vm.serviceInfo) {
			var serviceSelectionElement: any = this.vm.serviceInfo[index];
			if (serviceSelectionElement.step === this.vm.currentJourneyStep) {
				if (serviceSelectionElement.type === 'RADIO') {
					for (var selectedServiceId in this.vm.selectedServiceIds) {
						if (selectedServiceId == serviceSelectionElement.id) {
							if (this.radioSelectedValue == serviceSelectionElement.id) {
								this.vm.selectedServiceIds[selectedServiceId] = true;
							} else {
								delete this.vm.selectedServiceIds[selectedServiceId];
							}
						}
					}
				}
			}
		}
		
		return this.isStepInvalid();
	}
	
	isStepInvalid() {
		this.vm.stepInvalid = false;
		var stepSelectionExists = false;
		MAIN: for (var index in this.vm.serviceInfo) {
			var serviceSelectionElement: any = this.vm.serviceInfo[index];
			if (serviceSelectionElement.step === this.vm.currentJourneyStep) {
				if (serviceSelectionElement.type === 'CHECKBOX' || serviceSelectionElement.type === 'RADIO') {
					if (!serviceSelectionElement.required) {
						stepSelectionExists = true;
						break MAIN;
					}
					for (var selectedServiceId in this.vm.selectedServiceIds) {
						if (serviceSelectionElement.id == selectedServiceId && this.vm.selectedServiceIds[selectedServiceId]) {
							stepSelectionExists = true;
							break MAIN;
						}
					}
				}
				if (serviceSelectionElement.type === 'TEXT_INPUT' || serviceSelectionElement.type === 'DATE') {
					if (serviceSelectionElement.required === 'MANDATORY') {
						for (var selectedServiceId in this.vm.selectedServiceIds) {
							if (serviceSelectionElement.id == selectedServiceId && this.vm.selectedServiceIds[selectedServiceId]) {
								stepSelectionExists = true;
								break MAIN;
							}
						}
					} else {
						stepSelectionExists = true;
						break MAIN;
					}
				}
			}
		}
		this.vm.stepInvalid = !stepSelectionExists;
		return this.vm.stepInvalid;
	}
	
	submit() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		if (this.vm.isSaving) {
			return;
		}
		var ticketServiceRequestOptions: Array<any> = [];
		for (var selectedServiceId in this.vm.selectedServiceIds) {
			for (var index in this.vm.serviceInfo) {
				var serviceSelectionElement: any = this.vm.serviceInfo[index];
				if (serviceSelectionElement.id == selectedServiceId && this.vm.selectedServiceIds[selectedServiceId]) {
					serviceSelectionElement.content = this.vm.selectedServiceIds[selectedServiceId];
					ticketServiceRequestOptions.push(serviceSelectionElement)
					
				}
			}
		}
		var submitData: any = {
			"type": this.vm.parentCategory,
			"selectedServiceRequestDetails": ticketServiceRequestOptions
		}
		submitData = this.preVisitRecordTicketForPersonService.addRecordTicketForPersonData(submitData);
		
		this.vm.isSaving = true;
		this.restService.savePreVisitNewGeneralServiceRequest(submitData)
			.then((response) => {
				this.vm.preVisitTicketId = response.id
				this.vm.showOnlyThankYouSection = true;
				this.vm.isSaving = false;
				deferred.resolve();
			})
			.catch((error) => {
				deferred.reject(error);
				this.vm.isSaving = false;
				console.log(error);
			});
		
		return deferred.promise;
	}
	
}